export enum ProductKeys {
  SECURE_WORKLOAD = 'secure-workload',
}

export enum ProductPermissionStatus {
  ADDED = 'added',
  DELETED = 'deleted',
  UNCHANGED = 'unchanged',
}
